import * as THREE from "three";
import Heatpoint from '../heatpointscontrol/heatpoint'
import gsap from "gsap";

const ANIMATION_NAMES = ['Ganze BrückeAction', 'Fahrrad.009Action.003', 'Fahrrad.009Action.002', 'Fahrrad.009Action.001', 'Cranks.010Action.001'];


export default class bikeBridge extends THREE.Object3D {
	constructor(pinColor, pinColorDark, camera, interactionManager, onPinClick, gltfanimations, mixer, visitedPinColor) {
		super();
	

		this.pinModel9 = new Heatpoint(null, "model/heatointbike.glb")
		setTimeout(() => {
			this.pinModel9.setColor(pinColor);
		}, 1000);
		this.pinModel9.position.set(-0.8, 0.40, 0.92);
		this.visited = false;
		interactionManager.add(this.pinModel9);

		this.pinModel9.addEventListener("click", (event) => {
			onPinClick();
			gsap.to(camera.position,  { x: -0.4, y: 0.7, z: 1.8, duration: 2.5, ease: "Power3.inOut" })
			this.visited = true;     
            this.triggerAnimations(gltfanimations, mixer, true);
           
		})

		this.pinModel9.addEventListener('mouseover', (event) => {
			document.body.style.cursor = 'pointer';
			this.pinModel9.setColor(pinColorDark);
		});
		this.pinModel9.addEventListener('mouseout', (event) => {
			document.body.style.cursor = 'default';
			if(!this.visited){
                this.pinModel9.setColor(pinColor);
            }
            else{
				this.pinModel9.setColor(visitedPinColor);
			}
		});

		this.add(this.pinModel9)
    	this.rotatePin();
	}
    getClipActions(gltfanimations, mixer) {
        return ANIMATION_NAMES.map(name => {
            const animation = THREE.AnimationClip.findByName(gltfanimations, name);
            return mixer.clipAction(animation);
        });
    }

    triggerAnimations(gltfanimations, mixer, modal) {
        setTimeout(() => {
            const clipActions = this.getClipActions(gltfanimations, mixer);
            clipActions.forEach(clip => {
                clip.reset().timeScale = 1;
                clip.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            });

            if (modal) {
                setTimeout(() => {
                    const modal9 = document.getElementById('modal9');
                    modal9.classList.remove('hidden');
                    modal9.addEventListener('click', function() {
                        modal9.classList.add('hidden');
                        clipActions.forEach(clip => clip.reset().timeScale = -1);
                    });
                }, 4000);
            }
        }, 1500);
    }

    resetAnimations(gltfanimations, mixer) {
		
    }

	rotatePin() {
		this.rotationData = { angle: 0 };
        gsap.to(this.rotationData, {
            angle: "+=" + 2 * Math.PI, // Add 360 degrees in radians
            duration: 10, // Define how fast you want a full rotation to be. Here it's set to 5 seconds.
            ease: "none", // Linear rotation
            onUpdate: () => {
                this.pinModel9.setRotationFromAxisAngle(new THREE.Vector3(0, 1, 0), this.rotationData.angle);
            },
            repeat: -1 // This will make the animation run indefinitely
        });
	}
}